import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Button, Flex, Title } from '@mantine/core'
import { useRouter } from 'next/router'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'
import { Page } from '@flecto/ui/saas'

import { FormCreateInsurancePolicy } from '../components/FormCreateInsurancePolicy/FormCreateInsurancePolicy'

export function PageCreateInsurance() {

  const [enableButton, setEnableButton] = useState(false)

  const { t } = useTranslation('saas', { keyPrefix: 'insurances' })
  const router = useRouter()

  return (
    <Page withContainer>
      <Page.Title>
        <Flex justify='space-between' align='center'>
          <Flex gap={'md'} align='center'>
            <ActionIcon
              onClick={() => {
                router.push('/insurances')
              }}
              variant='light'
              color='gray'
            >
              <Icon icon={faTimes} size='lg' />
            </ActionIcon>
            <Title order={3}>{t('create_insurance.title')}</Title>
          </Flex>

          <Button
            type='submit'
            form='create-insurance'
            data-testid='btn-save'
            disabled={!enableButton}
          >
            {t('create_insurance.create_insurance_btn')}
          </Button>
        </Flex>
      </Page.Title>
      <Page.Content>
        <FormCreateInsurancePolicy
          id='create-insurance'
          setEnableButton={setEnableButton}
        />
      </Page.Content>
    </Page>
  )
}
